import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { styled } from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  list: {
    width: 300,
  },
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "space-between",
}));

const FormElements = (props) => {

  const classes = useStyles();

  return (
    <Droppable  droppableId={"form-elements-droppable"} isDropDisabled={true}>
      {(provided) => {
        return (
          <div
            className={classes.list}
            role="presentation"
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            <DrawerHeader>
              <Typography variant="h6" style={{ padding: "15px", width:"100%", textAlign:"center"}} >
                FORM ELEMENTS
              </Typography>
            </DrawerHeader>
            <Divider />
            <List style={{padding:"15px"}}>
              {
                window.GroupName.map((GroupName)=>{
                  let newFormElements = [...window.FormEl]
                  let FormElements = newFormElements.filter((el)=>{return el['GroupName'] === GroupName.Name && el['Enable'] === 'TRUE'})
                  if(FormElements.length === 0){
                    return ""
                  }
                  return (
                    <div key={`${GroupName.Name}-label`}>
                      <Typography style={{ padding: "10px 15px", color:"black", fontWeight:"700" }}>{GroupName.Name}</Typography>
                      {
                        FormElements.map((element, index) => {
                          return (
                            <Draggable
                              key={`${element.AppearanceGroup}##${element.XlsType}`}
                              draggableId={`${element.AppearanceGroup}##${element.XlsType}`}
                              index={index}
                            >
                              {(provided, snapshot) => {
                                return (
                                  <Box
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <ListItem
                                      button
                                      key={`${element.AppearanceGroup}##${element.XlsType}-item`}
                                      style={{
                                        border: "1px solid "+GroupName.Color,
                                        borderRadius: "4px",
                                        margin: "10px 0px",
                                        backgroundColor: GroupName.Color+"0f"
                                      }}
                                    >
                                      <ListItemIcon>
                                        <i className={element.IconURL} style={{color: element.IconColor}}></i>
                                      </ListItemIcon>
                                      <ListItemText primary={element.Title} />
                                    </ListItem>
                                  </Box>
                                );
                              }}
                            </Draggable>
                          );
                        })
                      }
                      <Divider />
                    </ div>
                  )
                })
              }
            </List>
          </div>
        );
      }}
    </Droppable>
  );
};

export default FormElements;
